export function initHeaderMenu({ headerEl, burgerBtn, navLinks }) {
  function closeMenu() {
    headerEl.classList.add('nav-closing');
    headerEl.classList.remove('nav-open');
    requestAnimationFrame(() => headerEl.classList.remove('nav-closing'));
    burgerBtn.setAttribute('aria-expanded', 'false');
  }

  burgerBtn.addEventListener('click', () => {
    const open = headerEl.classList.toggle('nav-open');
    burgerBtn.setAttribute('aria-expanded', String(open));
  });

  navLinks.forEach((link) => {
    link.addEventListener('click', () => {
      if (headerEl.classList.contains('nav-open')) closeMenu();
    });
  });

  // Ferme le menu au clic/tap n'importe où en dehors (page en dessous) —
  // le clic sur le bouton burger et les liens du menu sont ignorés ici
  // puisqu'ils sont dans headerEl et déjà gérés par leurs propres listeners
  // ci-dessus.
  //
  // Sur mobile, un tap "en dehors" juste après un précédent tap peut être
  // interprété par le navigateur comme un double-tap-zoom plutôt qu'un
  // simple clic (le "click" synthétisé est alors retardé, voire jamais
  // déclenché, et la page zoome à la place) : on gère donc la fermeture dès
  // le touchend, avant que le navigateur n'ait à trancher, et on bloque le
  // zoom pour ce tap précis. Le listener "click" reste nécessaire pour la
  // souris/trackpad (qui ne déclenche jamais de touchend).
  document.addEventListener('touchend', (event) => {
    if (!headerEl.classList.contains('nav-open')) return;
    if (headerEl.contains(event.target)) return;
    event.preventDefault();
    closeMenu();
  }, { passive: false });

  document.addEventListener('click', (event) => {
    if (!headerEl.classList.contains('nav-open')) return;
    if (headerEl.contains(event.target)) return;
    closeMenu();
  });
}
